import './header.css';

function Header() {
  return (
    <div id='home' className='container header-container'>
      <h3>
        <p>
          I<span>'</span>m
        </p>
        Ugyel21
      </h3>
      <h2>Software Developer</h2>
    </div>
  );
}
export default Header;
